import React from 'react';
import { useTranslation } from 'react-i18next';

import { faUserGraduate } from '@fortawesome/free-solid-svg-icons/faUserGraduate';
import { faUserTie } from '@fortawesome/free-solid-svg-icons/faUserTie';
import { faSchool } from '@fortawesome/free-solid-svg-icons/faSchool';
import { faNewspaper } from '@fortawesome/free-regular-svg-icons/faNewspaper';
import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons/faCalendarCheck';
import { faColumns } from '@fortawesome/free-solid-svg-icons/faColumns';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons/faBullhorn';
import { faStarHalfAlt } from '@fortawesome/free-solid-svg-icons/faStarHalfAlt';
import { faLevelUpAlt } from '@fortawesome/free-solid-svg-icons/faLevelUpAlt';
import { faChartPie } from '@fortawesome/free-solid-svg-icons/faChartPie';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { faCrown } from '@fortawesome/free-solid-svg-icons/faCrown';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog.js';
import { faShare } from '@fortawesome/free-solid-svg-icons/faShare.js';
import { faCertificate } from '@fortawesome/free-solid-svg-icons/faCertificate.js';

import NavListItem from './NavListItem.jsx';
import LangSwitcher from './LangSwitcher.jsx';

import { env } from '../../config';

const { roles } = env.user;

const Nav = () => {
  const { t } = useTranslation();
  const labelRankings = roles.includes('schoolAdmin')
    ? 'InSchoolRankings'
    : 'Rankings';

  const links = [
    ...(roles.includes('schoolAdmin')
      ? [
        {
          to: '/admin/dashboard',
          icon: faTachometerAlt,
          label: t('Dashboard'),
        },
      ]
      : []),

    ...(roles.includes('admin')
      ? [
        {
          to: '/admin/users',
          icon: faUser,
          label: t('Users'),
          links: [
            {
              to: '/admin/users/admins',
              icon: faUserTie,
              label: t('Admins'),
            },
            {
              to: '/admin/users/students',
              icon: faUserGraduate,
              label: t('Students'),
            },
            { to: '/admin/users/opens', icon: faUsers, label: t('Opens') },
          ],
        },

        { to: '/admin/schools', icon: faSchool, label: t('School') },
        { to: '/admin/articles', icon: faNewspaper, label: t('Articles') },
      ]
      : []),

    {
      to: '/admin/assignments',
      icon: faCalendarCheck,
      label: t('Assignments'),
    },
    {
      to: '/admin/trainings',
      icon: faCalendarCheck,
      label: t('trainings'),
    },
    ...(roles.includes('admin')
      ? [
        { to: '/admin/setting', icon: faCog, label: t('Global Setting') },
        { to: '/admin/site', icon: faColumns, label: t('Site') },
        {
          to: '/admin/announcements',
          icon: faBullhorn,
          label: t('Announcements'),
        },
        { to: '/admin/shares', icon: faShare, label: t('Shares') },
        { to: '/admin/levels', icon: faLevelUpAlt, label: t('Levels') },
      ]
      : []),

    ...(roles.includes('schoolAdmin') && env.user.schoolClass
      ? [
        {
          to: '/admin/users/students',
          icon: faUserGraduate,
          label: t('Students'),
        },
      ]
      : []),

    ...(roles.includes('schoolAdmin') && !env.user.schoolClass
      ? [
        {
          to: `/admin/schools/${env.user.school}`,
          icon: faUser,
          label: t('Users'),
        },
        {
          to: '/admin/users/students',
          icon: faUserGraduate,
          label: t('Students'),
        },
      ]
      : []),

    {
      to: '/admin/reports',
      icon: faChartPie,
      label: t('Reports'),
      links: [
        {
          to: '/admin/reports/scores',
          icon: faStarHalfAlt,
          label: t('Scores'),
        },
        {
          to: '/admin/reports/performance',
          icon: faChartLine,
          label: t('Performance'),
        },
        {
          to: '/admin/reports/rankings',
          icon: faCrown,
          label: t(labelRankings),
        },
        // { to: '/admin/reports/articles', icon: faNewspaper, label: t('Articles') },
        // {
        //   to: '/admin/reports/achievements',
        //   icon: faTrophy,
        //   label: t('Achievements'),
        // },
        {
          to: '/admin/reports/participations',
          icon: faTrophy,
          label: t('participations'),
        },
      ],
    },

    // ...(roles.includes('schoolAdmin')
    //   ? [
    //     {
    //       to: '/admin/users/certificates',
    //       icon: faCertificate,
    //       label: t('Certificate Download'),
    //     },
    //   ] : []),

    {
      href: '/logout',
      icon: faPowerOff,
      label: t('Logout'),
    },
  ];

  return (
    <nav className="col main-nav bg-white pr-0 py-5">
      <div className="nav flex-column pl-3">
        <LangSwitcher />
        {links.map((l, i) => (
          <NavListItem key={i} {...l}>
            {l.links
              && l.links.map((ll, ii) => <NavListItem key={ii} {...ll} />)}
          </NavListItem>
        ))}
      </div>
    </nav>
  );
};

export default Nav;
